import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePersona} from '../hooks/usePersona';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {usePersonasSelection} from "../hooks/usePersonasSelection.ts";
import {Grid} from "@mantine/core";
import {IndexPage as MessagesPage} from "../../messages/pages/IndexPage.tsx";


export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = usePersona(componentId);

    const {handleClearSelection} = usePersonasSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (loading || !component) {
        return <PlatformLoader message='Loading persona...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.givenName ? [component.givenName, component.familyName].join(' ') : component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Grid>
                    <Grid.Col span={{
                        base: 4,
                        sm: 12
                    }}>
                        <Profile record={component}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 8,
                        sm: 12
                    }}>
                        <MessagesPage/>
                    </Grid.Col>
                </Grid>
                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={component}
                        handleSubmit={updateRecord}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
